import { render, staticRenderFns } from "./headers-lnb.vue?vue&type=template&id=53f2d90e&scoped=true"
import script from "./headers-lnb.vue?vue&type=script&lang=js"
export * from "./headers-lnb.vue?vue&type=script&lang=js"
import style0 from "./headers-lnb.vue?vue&type=style&index=0&id=53f2d90e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f2d90e",
  null
  
)

export default component.exports